import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{directives:[{name:"show",rawName:"v-show",value:(_vm.billPlan === 'starter'),expression:"billPlan === 'starter'"}],attrs:{"color":"info","small":"","link":"","elevation":"0","href":"/fr/tarifs","target":"_blank"}},[_vm._v(_vm._s(_vm.label)),_c(VIcon,{attrs:{"right":"","small":""}},[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }